import { Reveal } from './Reveal';

/**
 * Bold, consistent hero for inner pages — brand gradient, floating glows,
 * film grain, a glass eyebrow pill, and a cream fade into the page.
 */
export function PageHero({
  eyebrow,
  title,
  children,
}: {
  eyebrow: string;
  title: React.ReactNode;
  children?: React.ReactNode;
}) {
  return (
    <section className="relative overflow-hidden isolate bg-mustard-green-dark">
      <div className="absolute inset-0 bg-brand-gradient" aria-hidden="true" />
      <div className="absolute -top-24 -right-16 w-[26rem] h-[26rem] rounded-full bg-mustard-gold/20 blur-3xl animate-float" aria-hidden="true" />
      <div className="absolute -bottom-28 -left-24 w-[26rem] h-[26rem] rounded-full bg-mustard-green-mid/25 blur-3xl animate-float-slow" aria-hidden="true" />
      <div className="absolute inset-0 noise opacity-[0.06] mix-blend-overlay" aria-hidden="true" />
      <div className="absolute -bottom-px left-0 right-0 h-24 bg-gradient-to-t from-mustard-cream to-transparent" aria-hidden="true" />
      <div className="section relative py-20 sm:py-28 text-center animate-fade-up">
        <span className="glass inline-flex items-center gap-2 rounded-full px-4 py-1.5 mb-5 text-xs font-semibold tracking-[0.12em] uppercase text-white/90">
          <span className="w-1.5 h-1.5 rounded-full bg-mustard-gold animate-glow-pulse" />
          {eyebrow}
        </span>
        <h1 className="font-display text-hero-sm sm:text-hero text-white mb-4 tracking-display">
          {title}
        </h1>
        {children && (
          <div className="text-white/70 max-w-2xl mx-auto leading-relaxed">{children}</div>
        )}
      </div>
    </section>
  );
}
